import { SignedURLDTO } from 'models/visuals'

export interface AssignmentDocumentDTO {
  /** Document sign url */
  signedUrl: SignedURLDTO,
  /** Document name */
  name: string,
  /** Document original name */
  originalName: string,
  /** Document extension */
  fileExtension: string
}

export enum DocestateStatusType {
  CUSTOMER_INTERACTION_OPENED = 'CUSTOMER_INTERACTION_OPENED',
  CUSTOMER_INTERACTION_ADMIN_RESPONSE = 'CUSTOMER_INTERACTION_ADMIN_RESPONSE',
  CUSTOMER_INTERACTION_USER_RESPONSE = 'CUSTOMER_INTERACTION_USER_RESPONSE',
  CUSTOMER_INTERACTION_CLOSED = 'CUSTOMER_INTERACTION_CLOSED',
  INTERN_STATUS_COMMENT = 'INTERN_STATUS_COMMENT',
  EXTERN_STATUS_COMMENT = 'EXTERN_STATUS_COMMENT',
  DOCUMENT_COMPLETED = 'DOCUMENT_COMPLETED',
  AUTOMATIC_REMINDER = 'AUTOMATIC_REMINDER',
  PHONE_TICKET_NOT_REACHED = 'PHONE_TICKET_NOT_REACHED',
  PHONE_TICKET_REACHED = 'PHONE_TICKET_REACHED',
  PHONE_TICKET_MAIL_REMINDER = 'PHONE_TICKET_MAIL_REMINDER',
  PHONE_TICKET_CREATED = 'PHONE_TICKET_CREATED',
  DOCUMENT_CANCELED = 'DOCUMENT_CANCELED',
  DOCUMENT_REQUESTED = 'DOCUMENT_REQUESTED',
  ORDER_CREATED = 'ORDER_CREATED',
}

export interface AssignmentDocumentStatusHistoryDTO {
  /** Document status ID */
  id: string,
  /** Docestate document ID */
  docestateDocumentId: string,
  /** Docestate status ID */
  docestateStatusId: number,
  /** Document status type */
  status: DocestateStatusType,
  /** Document status message */
  statusMessage: string,
  /** Document status timestamp */
  timestamp: string,
  /** Document status created at */
  createdAt: string,
}
